import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#1E3A8A] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="space-y-4">
            <div className="flex items-center gap-3">
              <img 
                src="https://customer-assets.emergentagent.com/job_53640627-9830-4adc-91a5-529f85e3f30c/artifacts/pm4tpcen_IWMC_logo_transparent.png" 
                alt="IWMC Logo" 
                className="h-12 w-auto brightness-0 invert"
              />
              <div>
                <p className="font-black" style={{ fontFamily: 'Merriweather, serif' }}>Integrated Wellness</p>
                <p className="text-sm text-white/70">Medical Center</p>
              </div>
            </div>
            <p className="text-white/70 text-sm leading-relaxed font-bold" style={{ fontFamily: 'Merriweather, serif' }}>
              Providing virtual-only telemedicine urgent care services to NY & NJ communities. 
              All visits conducted via the Spruce Health app.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-black mb-4" style={{ fontFamily: 'Merriweather, serif' }}>Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/book-appointment" className="text-white/70 hover:text-white transition-colors text-sm font-bold" style={{ fontFamily: 'Merriweather, serif' }}>
                  Book Virtual Visit
                </Link>
              </li>
              <li>
                <Link to="/programs" className="text-white/70 hover:text-white transition-colors text-sm font-bold" style={{ fontFamily: 'Merriweather, serif' }}>
                  Wellness Programs
                </Link>
              </li>
              <li>
                <Link to="/chatbot" className="text-white/70 hover:text-white transition-colors text-sm font-bold" style={{ fontFamily: 'Merriweather, serif' }}>
                  AI Health Assistant
                </Link>
              </li>
              <li>
                <Link to="/pharmacy" className="text-white/70 hover:text-white transition-colors text-sm font-bold" style={{ fontFamily: 'Merriweather, serif' }}>
                  Pharmacy Delivery
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-black mb-4" style={{ fontFamily: 'Merriweather, serif' }}>Our Services</h3>
            <ul className="space-y-3">
              <li className="text-white/70 text-sm font-bold" style={{ fontFamily: 'Merriweather, serif' }}>Virtual Urgent Care</li>
              <li className="text-white/70 text-sm font-bold" style={{ fontFamily: 'Merriweather, serif' }}>Follow-Up Consultations</li>
              <li className="text-white/70 text-sm font-bold" style={{ fontFamily: 'Merriweather, serif' }}>Async Medication Refills</li>
              <li className="text-white/70 text-sm font-bold" style={{ fontFamily: 'Merriweather, serif' }}>Quick Pharmacy Delivery</li>
              <li className="text-white/70 text-sm font-bold" style={{ fontFamily: 'Merriweather, serif' }}>Spruce Health Messaging</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-black mb-4" style={{ fontFamily: 'Merriweather, serif' }}>Contact Us</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Phone className="w-5 h-5 text-[#3B82F6] mt-0.5" />
                <div>
                  <p className="text-sm font-black" style={{ fontFamily: 'Merriweather, serif' }}>Call/Text</p>
                  <a href="tel:2015353582" className="text-white/70 hover:text-white text-sm font-bold" style={{ fontFamily: 'Merriweather, serif' }}>
                    (201) 535-3582
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-5 h-5 text-[#3B82F6] mt-0.5" />
                <div>
                  <p className="text-sm font-black" style={{ fontFamily: 'Merriweather, serif' }}>Email</p>
                  <a href="mailto:info@integratedwellnessny.com" className="text-white/70 hover:text-white text-sm font-bold" style={{ fontFamily: 'Merriweather, serif' }}>
                    info@integratedwellnessny.com
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-[#3B82F6] mt-0.5" />
                <div>
                  <p className="text-sm font-black" style={{ fontFamily: 'Merriweather, serif' }}>Service Area</p>
                  <p className="text-white/70 text-sm font-bold" style={{ fontFamily: 'Merriweather, serif' }}>New York & New Jersey</p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Clock className="w-5 h-5 text-[#3B82F6] mt-0.5" />
                <div>
                  <p className="text-sm font-black" style={{ fontFamily: 'Merriweather, serif' }}>Hours</p>
                  <p className="text-white/70 text-sm font-bold" style={{ fontFamily: 'Merriweather, serif' }}>Monday-Friday: 9:00AM - 7:00PM</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-white/20 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/70 text-sm font-bold" style={{ fontFamily: 'Merriweather, serif' }}>
            © {new Date().getFullYear()} Integrated Wellness Medical Center. All rights reserved.
          </p>
          <div className="flex gap-6">
            <Link to="/privacy" className="text-white/70 hover:text-white text-sm font-bold" style={{ fontFamily: 'Merriweather, serif' }}>
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-white/70 hover:text-white text-sm font-bold" style={{ fontFamily: 'Merriweather, serif' }}>
              Terms of Service
            </Link>
            <Link to="/hipaa" className="text-white/70 hover:text-white text-sm font-bold" style={{ fontFamily: 'Merriweather, serif' }}>
              HIPAA Notice
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
